import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { useDocTitle } from "../../components/_common/DocTitle";

import { Divider, Fab, Grid, List, ListItem, ListItemIcon, ListItemText, Typography } from "@material-ui/core";
import { BlurOnOutlined, MenuBook } from "@material-ui/icons";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { makeStyles } from "@material-ui/styles";

import axios from "axios";
import APIs from "../../APIs";

const Preloader = React.lazy(() => import("../../components/_common/Preloader"));

const regex = /(<([^>]+)>)|\t|\n|&nbsp;/gi;
const AccessibilityTooltip = React.lazy(() => import("../../components/_common/AccessibilityTooltip"));

const useStyles = makeStyles((theme) => ({
    bigTitle: {
        fontSize: "34px",
        margin: theme.spacing(0, 4, 4, 4),
        textAlign: "center",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.125rem",
            fontWeight: theme.typography.fontWeightMedium,
        },
    },
    
    titleContainer: {
        display: "flex",
        alignItems: "center",
        position: "relative",
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: {
            alignItems: "flex-end",
        },
    },
    name: {
        fontSize: "clamp(1.25rem, 2vw,2rem)",
        fontWeight: "normal",
        // padding: "0 100px",
        // margin: "32px auto",
        margin: theme.spacing(8, 0, 8, 0),
        textAlign: "center",
        display: "flex",
        flexGrow: 1,
        alignItems: "flex-start",
        justifyContent: "center",
        gap: 16,
        [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(4, 0, 2, 0),
            textAlign: "left",
            // fontSize: "1rem",
            // margin: theme.spacing(4, 1, 2, 1),
        },
    },
    title: {
        // fontSize: "14px",
        fontSize: "clamp(13px, 1vw, 1.125rem)",
        fontWeight: theme.typography.fontWeightBold,
        [theme.breakpoints.down("sm")]: {
            // fontSize: "0.75rem",
        },
    },
    text: {
        // fontSize: "14px",
        fontSize: "clamp(13px, 1vw, 1.125rem)",
        [theme.breakpoints.down("sm")]: {
            textWrap: "pretty",
            paddingLeft: theme.spacing(2),
        },
    },
    topMargin: {
        marginTop: theme.spacing(6),
        [theme.breakpoints.down("sm")]: {
            marginTop: theme.spacing(3),
        },
    },
    inlineFlex: {
        display: "inline-flex",
    },
    backButton: {
        // position: "absolute",
        // right: "20px",
        [theme.breakpoints.down("sm")]: {
            position: "absolute",
            right: 0,
        },
    },
    srOnly: {
        position: "absolute",
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        border: 0,
    },
}));

const RSISYSTEMY_InfoPage = (props) => {
    const classes = useStyles();
    const { i18n, t } = useTranslation();
    useDocTitle(t("pages.systemsPageTitle"));

    const params = useParams();

    const location = useLocation();
    const search = new URLSearchParams(location.search);
    const from = search?.get("from");

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(
        () => {
            const id = params?.id || props.match.params.id;

            // data ||
            axios
                // .get(`${APIs.dataURL.rsisystemy}/${props.match.params.id}`)
                .get(`${APIs.dataURL.rsisystemy}/${id}`)
                // .get('./devData/s1374.json')
                .then((result) => {
                    const apiData = result.data; //.results.map(item => ({ ...item, nazwa_systemu: item.nazwa_systemu.replace(/(<([^>]+)>)|\t|\n/gi, "") }));

                    setData(apiData);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    setLoading(false);

                    setTimeout(() => {
                        window.scrollTo({ top: 0 });
                    }, 500);
                });
        },
        // eslint-disable-next-line
        [
            // data,
            // location,
            params,
        ]
    );

    const [isMobile, setIsMobile] = useState(window.innerWidth < 599.95);
    useEffect(() => {
        window.addEventListener("resize", () => {
            setIsMobile(window.innerWidth < 599.96);
        });
    }, [isMobile]);

    return (
        <>
            <Helmet>
                <title>{`${data?.nazwa_systemu} - Repozytorium Systemów Informacyjnych`}</title>
            </Helmet>

            {loading ? (
                <Preloader />
            ) : (
                <>
                    <Grid container className={classes.titleContainer}>
                        <span />
                        <Typography variant={"h2"} className={classes.name} id={"page-content"} color={"primary"}>
                            {data.nazwa_systemu.replace(regex, "")}

                            {!!data.api && (
                                <img
                                    src="/icons/API-chips.png"
                                    alt=""
                                    style={{
                                        marginTop: isMobile ? "0.125em" : "0.25em",
                                        height: "clamp(20px, 1em, 24px)",
                                        width: "auto",
                                    }}
                                />
                            )}
                        </Typography>

                        <a href={`/${i18n.language}/${from || "rsisystemy"}`} className={classes.backButton}>
                            <AccessibilityTooltip
                                arrow={false}
                                placement="top-end"
                                title={`Wróć do spisu ${from === "rsigestorzy" ? "gestorów" : "systemów"}`}
                            >
                                <Fab
                                    // style={{ color: "black" }}
                                    size={isMobile ? "small" : "medium"}
                                    color={"primary"}
                                    component={"span"}
                                    ref={(ref) => {
                                        if (ref) {
                                            ref.removeAttribute("tabindex");
                                        }
                                    }}
                                    role={"presentation"}
                                >
                                    <ArrowBackIcon fontSize={isMobile ? "small" : "medium"} />
                                    <span className={classes.srOnly}>{`Wróć`}</span>
                                </Fab>
                            </AccessibilityTooltip>
                        </a>
                    </Grid>

                    <Divider style={{ marginBottom: 16 }} />

                    <Grid container spacing={1}>
                        <Grid item xs={12} md>
                            <Typography variant={"h3"} className={classes.title}>
                                {t("Nazwa skrócona")}
                                {":"}
                            </Typography>
                            <Typography variant={"body2"} className={classes.text}>
                                {data.nazwa_systemu_skr ? (
                                    data.nazwa_systemu_skr.replace(regex, "")
                                ) : (
                                    <em>{t("Brak")}</em>
                                )}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <Typography variant={"h3"} className={classes.title}>
                                {t("Gestor")}
                                {":"}
                            </Typography>
                            <Typography variant={"body2"} className={classes.text}>
                                {data.gestor ? data.gestor.replace(regex, "") : ""}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md>
                            <Typography variant={"h3"} className={classes.title}>
                                {t("Sposób prowadzenia")}
                                {":"}
                            </Typography>
                            <Typography variant={"body2"} className={classes.text}>
                                {data.sposob_prowadzenia_systemu
                                    ? data.sposob_prowadzenia_systemu.replace(regex, "")
                                    : ""}
                                {data.poziom_gromadzenia_danych
                                    ? ", " + data.poziom_gromadzenia_danych.replace(regex, "")
                                    : ""}
                                {!data.sposob_prowadzenia_systemu && !data.poziom_gromadzenia_danych && "-"}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md>
                            <Typography variant={"h3"} className={classes.title}>
                                {t("Zasięg")}
                                {":"}
                            </Typography>
                            <Typography variant={"body2"} className={classes.text}>
                                {data.czy_krajowy && t("krajowy")}
                                {data.czy_lokalny && t("lokalny")}
                                {!data.czy_krajowy && !data.czy_lokalny && "-"}
                            </Typography>
                        </Grid>
                    </Grid>

                    {data.api ? (
                        <Grid container spacing={1} className={classes.topMargin}>
                            <Grid item xs={12}>
                                <Typography variant={"h3"} className={classes.title}>
                                    {t("API")}
                                    {":"}
                                </Typography>
                                <Typography variant={"body2"} className={classes.text}>
                                    {data.api ? t("Tak{{dot}}", { dot: "." }) : t("Nie{{dot}}", { dot: "." })}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant={"h3"} className={classes.title}>
                                    {t("Adres API")}
                                    {":"}
                                </Typography>
                                <Typography variant={"body2"} className={classes.text}>
                                    {data.api ? (
                                        <a href={data.czy_api}>{t("Przejdź do strony z API{{dot}}", { dot: "." })}</a>
                                    ) : (
                                        <em style={{ fontSize: "0.9em" }}>{t("Brak")}</em>
                                    )}
                                </Typography>
                            </Grid>
                        </Grid>
                    ) : null}

                    {!!data.aktyprawne && !!data.aktyprawne.length && (
                        <Grid container className={classes.topMargin}>
                            <Grid item xs={12}>
                                <Typography variant={"h3"} className={classes.title}>
                                    {t("Podstawa prawna")}
                                    {":"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <List dense style={{ padding: 0 }}>
                                    {data.aktyprawne.map((akt) => {
                                        return (
                                            <ListItem
                                                key={akt.id_akt}
                                                alignItems={"flex-start"}
                                                style={{
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    padding: isMobile ? 0 : undefined,
                                                }}
                                            >
                                                {isMobile ? null : (
                                                    <ListItemIcon style={{ minWidth: 40 }}>
                                                        <MenuBook fontSize={"small"} />
                                                    </ListItemIcon>
                                                )}
                                                <ListItemText
                                                    disableTypography
                                                    primary={
                                                        <Typography variant={"body2"} className={classes.text}>
                                                            {akt.nazwa ? akt.nazwa.replace(regex, "") : ""}
                                                        </Typography>
                                                    }
                                                    secondary={
                                                        <Typography variant={"body2"} className={classes.text}>
                                                            <small>
                                                                <b>
                                                                    <em>
                                                                        {t("Miejsce publikacji")}
                                                                        {":"}&nbsp;&nbsp;
                                                                    </em>
                                                                </b>
                                                                {akt.miejsce_publikacji}
                                                            </small>
                                                        </Typography>
                                                    }
                                                    classes={{ primary: classes.text, secondary: classes.text }}
                                                />
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            </Grid>
                        </Grid>
                    )}

                    {data.cel_systemu && (
                        <Grid container className={classes.topMargin}>
                            <Grid item xs={12} md={12}>
                                <Typography variant={"h3"} className={classes.title}>
                                    {t("Cel systemu")}
                                    {":"}
                                </Typography>
                                <Typography variant={"body2"} className={classes.text}>
                                    {data.cel_systemu.replace(regex, "")}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}

                    {!!data?.forma_prowadzenia_systemu && (
                        <Grid container className={classes.topMargin}>
                            <Grid item xs={12} md={12}>
                                <Typography variant={"h3"} className={clsx(classes.title, classes.inlineFlex0)}>
                                    {t("Forma prowadzenia systemu")}
                                    {":"} &nbsp;
                                </Typography>
                                <Typography variant={"body2"} className={clsx(classes.text, classes.inlineFlex0)}>
                                    {data?.forma_prowadzenia_systemu?.replace(regex, "")}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}

                    {!!data?.stan_wdrozenia_systemu && (
                        <Grid container className={classes.topMargin}>
                            <Grid item xs={12} md={12}>
                                <Typography variant={"h3"} className={clsx(classes.title, classes.inlineFlex0)}>
                                    {t("Stan wdrożenia systemu")}
                                    {":"} &nbsp;
                                </Typography>
                                <Typography variant={"body2"} className={clsx(classes.text, classes.inlineFlex0)}>
                                    {data?.stan_wdrozenia_systemu?.replace(regex, "")}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}

                    {data?.stan_wdrozenia_systemu?.toLowerCase() !== "wdrożony" && (
                        <Grid container className={classes.topMargin}>
                            <Grid item xs={12} md={12}>
                                <Typography variant={"h3"} className={classes.title}>
                                    {t("Planowany termin wdrożenia")}
                                    {":"}
                                </Typography>
                                <Typography variant={"body2"} className={classes.text}>
                                    {data?.planowany_termin_wdrozenia?.replace(regex, "")}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}

                    {data?.zmiany_planowane !== null && (
                        <Grid container className={classes.topMargin}>
                            <Grid item xs={12} md={12}>
                                <Typography variant={"h3"} className={classes.title}>
                                    {t("Zmiany planowane do wprowadzenia w systemie")}
                                    {":"}
                                </Typography>
                                <Typography variant={"body2"} className={classes.text}>
                                    {data?.zmiany_planowane?.replace(regex, "")}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}

                    {data.zrodla_danych_czestotliwosc_aktualizacji && (
                        <Grid container className={classes.topMargin}>
                            <Grid item xs={12} md={12}>
                                <Typography variant={"h3"} className={classes.title}>
                                    {t("Źródła i częstotliwość aktualizacji")}
                                    {":"}
                                </Typography>

                                <Typography
                                    className={classes.text}
                                    variant="body2"
                                    component={"div"}
                                    dangerouslySetInnerHTML={{
                                        __html: data.zrodla_danych_czestotliwosc_aktualizacji,
                                    }}
                                ></Typography>
                            </Grid>
                        </Grid>
                    )}
                    {data.termin_formy_udostepniania_danych && (
                        <Grid container className={classes.topMargin}>
                            <Grid item xs={12} md={12}>
                                <Typography variant={"h3"} className={classes.title}>
                                    {t("Terminy i formy udostępniania")}
                                    {":"}
                                </Typography>
                                <Typography variant={"body2"} className={classes.text}>
                                    {data.termin_formy_udostepniania_danych.replace(regex, "")}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}
                    {data.obiekty && data.obiekty.length && (
                        <Grid container className={classes.topMargin}>
                            <Grid item xs={12}>
                                <Typography variant={"h3"} className={classes.title}>
                                    {t("Obiekty opisywane w systemie")}
                                    {":"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                {data.obiekty.map((object) => {
                                    return (
                                        <List dense style={{ padding: 0 }} key={object.id_obiektu}>
                                            <ListItem style={{ paddingTop: 0, paddingBottom: 0 }}>
                                                <ListItemText
                                                    disableTypography
                                                    primary={
                                                        <>
                                                            <Typography
                                                                variant={"h4"}
                                                                className={clsx(classes.title, classes.inlineFlex)}
                                                            >
                                                                {t("Typy")}
                                                                {":"} &nbsp;
                                                            </Typography>
                                                            <Typography
                                                                variant={"body2"}
                                                                className={clsx(classes.text, classes.inlineFlex)}
                                                            >
                                                                {object.typ_obiektu
                                                                    ? object.typ_obiektu.replace(regex, "")
                                                                    : ""}
                                                            </Typography>
                                                        </>
                                                    }
                                                    classes={{ primary: classes.text, secondary: classes.text }}
                                                />
                                            </ListItem>

                                            <ListItem style={{ paddingTop: 0, paddingBottom: 0 }}>
                                                <ListItemText
                                                    disableTypography
                                                    primary={
                                                        <>
                                                            <Typography
                                                                variant={"h4"}
                                                                className={clsx(classes.title, classes.inlineFlex)}
                                                            >
                                                                {t("Nazwa")}
                                                                {":"} &nbsp;
                                                            </Typography>
                                                            <Typography
                                                                variant={"body2"}
                                                                className={clsx(classes.text, classes.inlineFlex)}
                                                            >
                                                                {object.nazwa_obiektu
                                                                    ? object.nazwa_obiektu.replace(regex, "")
                                                                    : ""}
                                                            </Typography>
                                                        </>
                                                    }
                                                    classes={{ primary: classes.text, secondary: classes.text }}
                                                />
                                            </ListItem>

                                            <ListItem style={{ paddingTop: 0, paddingBottom: 0 }}>
                                                <ListItemText
                                                    disableTypography
                                                    primary={
                                                        <>
                                                            <Typography
                                                                variant={"h4"}
                                                                className={clsx(classes.title, classes.inlineFlex)}
                                                            >
                                                                {t("Opis")}
                                                                {":"} &nbsp;
                                                            </Typography>
                                                            <Typography
                                                                variant={"body2"}
                                                                className={clsx(classes.text, classes.inlineFlex)}
                                                            >
                                                                {object.opis_obiektu
                                                                    ? object.opis_obiektu.replace(regex, "")
                                                                    : ""}
                                                            </Typography>
                                                        </>
                                                    }
                                                    classes={{ primary: classes.text, secondary: classes.text }}
                                                />
                                            </ListItem>
                                            {object.cechyobiektu && object.cechyobiektu.length && (
                                                <>
                                                    <ListItem style={{ paddingTop: 0, paddingBottom: 0 }}>
                                                        <ListItemText
                                                            disableTypography
                                                            primary={
                                                                <>
                                                                    <Typography
                                                                        variant={"h4"}
                                                                        className={classes.title}
                                                                    >
                                                                        {t("Cechy informacyjne opisujące obiekt")}
                                                                        {":"}
                                                                    </Typography>
                                                                    <List dense style={{ padding: 0 }}>
                                                                        {object.cechyobiektu.map((cecha) => {
                                                                            return (
                                                                                <ListItem
                                                                                    alignItems={"flex-start"}
                                                                                    style={{
                                                                                        paddingTop: 0,
                                                                                        paddingBottom: 0,
                                                                                    }}
                                                                                    key={cecha.id_cechy}
                                                                                >
                                                                                    <ListItemIcon
                                                                                        style={{ minWidth: 32 }}
                                                                                    >
                                                                                        <BlurOnOutlined
                                                                                            fontSize={"small"}
                                                                                        />
                                                                                    </ListItemIcon>
                                                                                    <ListItemText
                                                                                        disableTypography
                                                                                        primary={
                                                                                            <Typography
                                                                                                variant={"body2"}
                                                                                                className={classes.text}
                                                                                            >
                                                                                                {cecha.nazwa_cechy.replace(
                                                                                                    regex,
                                                                                                    ""
                                                                                                )}
                                                                                            </Typography>
                                                                                        }
                                                                                        classes={{
                                                                                            primary: classes.text,
                                                                                            secondary: classes.text,
                                                                                        }}
                                                                                    />
                                                                                </ListItem>
                                                                            );
                                                                        })}
                                                                    </List>
                                                                </>
                                                            }
                                                            classes={{ primary: classes.text, secondary: classes.text }}
                                                        />
                                                    </ListItem>
                                                </>
                                            )}
                                        </List>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    )}
                </>
            )}
        </>
    );
};

export default RSISYSTEMY_InfoPage;
